import React, { Component } from 'react';

import imgFirebase from '../assets/images/ic_firebase.png'
import imgReact from '../assets/images/ic_reactjs.png'
import imgVue from '../assets/images/ic_vue.png'
import imgNuxt from '../assets/images/ic_nuxtjs.png'

class SectionSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {  }
  }
  render() { 
    return (
      <section className="ftco-section ftco-no-pb ftco-no-pt">
        <div className="container-fluid px-0" style={{ background: '#0094a7' }}>
          <div className="justify-content-center pt-5">
            <div className="col-md-12 heading-section text-center" data-aos="fade-up">
              <span className="subheading">Technology Support</span>
            </div>
          </div>
          <div className="row no-gutters wrapSupport" data-aos="fade-up" data-aos-once="-200">
            <div className="col-md-6 col-lg-3">
              <img src={imgFirebase} />
              <label>Firebase</label>
            </div>
            <div className="col-md-6 col-lg-3">
              <img src={imgReact} />
              <label>React Js</label>
            </div>
            <div className="col-md-6 col-lg-3">
              <img src={imgVue} />
              <label>Vue Js</label>
            </div>
            <div className="col-md-6 col-lg-3">
              <img src={imgNuxt} />
              <label>Nuxt Js</label>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionSupport;